module.exports = __webpack_public_path__ + "static/img/spring.1bc7471b.png";